import { z } from "zod";

// Wire-shape for a single agent record returned by `agencyInfoQuery`. The
// policy / claim / agency hooks all read the same projection, so share the
// schema instead of copying it three times. Dates serialize to ISO strings
// over the wire — declared as nullable strings.
export const AgentSchema = z.object({
  agentNumber: z.string(),
  agentName: z.string().nullable(),
  agentAddress1: z.string().nullable(),
  agentAddress2: z.string().nullable(),
  agentCityStateZip: z.string().nullable(),
  agentCity: z.string().nullable(),
  agentState: z.string().nullable(),
  agentZipCode: z.string().nullable(),
  agentPhoneNumber: z.string().nullable(),
  agentScorecardGroup: z.string().nullable(),
  agentContractedYn: z.string().nullable(),
  agentScorecardContractedYn: z.string().nullable(),
  agentAuthorizationStartDate: z.string().nullable(),
  agentAuthorizationEndDate: z.string().nullable(),
  agentContractedStartDate: z.string().nullable(),
  agentContractedEndDate: z.string().nullable(),
  agentWebsite: z.string().nullable(),
  agentFax: z.string().nullable(),
  agentStatus: z.string().nullable(),
});

export const AgencyRefSchema = z.object({
  agencyCode: z.string().nullable(),
  regionName: z.string().nullable(),
});

export const AgencyDetailSchema = z.object({
  agent: AgentSchema.nullable(),
  agency: AgencyRefSchema.nullable(),
});

export type Agent = z.infer<typeof AgentSchema>;
export type AgencyRef = z.infer<typeof AgencyRefSchema>;
export type AgencyDetail = z.infer<typeof AgencyDetailSchema>;

// Scorecard-group dialog: lists every agent in the same scorecard group as
// the seed agent, with a small thin projection. Used only by the
// ScorecardGroupDialog component.
export const ScorecardAgentSchema = z.object({
  id: z.string(),
  agentNumber: z.string(),
  agentName: z.string(),
  agentTier: z.string().nullable(),
  agentContractedYn: z.string().nullable(),
  agentScorecardGroup: z.string().nullable(),
});
export const ScorecardAgentsSchema = z.array(ScorecardAgentSchema);
export type ScorecardAgent = z.infer<typeof ScorecardAgentSchema>;
